
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { request } from "../../utils/request";
// Insert Payment
export const fetchSuccess = createAsyncThunk(
    "posts/fetchSuccess",
    async ({paymentId,PayerID},thunkApi) => {
   
      const { rejectWithValue } = thunkApi;
      try {
        const res = await request.get(`/payments/success?PayerID=${PayerID}&paymentId=${paymentId}`);
        console.log(res.data);
        
        return res.data;
      } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
      }
    }
  );
  const initialState = { records: [], Loading: false, erorr: null, reco: [] };
  const successSlice = createSlice({
    name:'success',
    initialState,
    extraReducers:(builder)=>{
    builder.addCase(fetchSuccess.pending, (state) => {
        state.Loading = true;
        state.erorr = null;
      });
      builder.addCase(fetchSuccess.fulfilled, (state, action) => {
        state.Loading = false;
        state.records = action.payload
      });
      builder.addCase(fetchSuccess.rejected, (state, action) => {
        state.Loading = false;
        state.erorr = action.payload;
      });
    }

  })
  export default successSlice.reducer